import { Reveal, Overline } from "./primitives";

const strip = ["speaking", "cnn-live", "paris", "on-tv"];

const achievements = [
  "Built businesses from scratch, including Sash, which grew to $30M+ in sales",
  "Spoken on national television",
  "Led organizations and traveled the world",
  "Raised children while creating from nothing, again and again",
];

export const AboutMe = () => (
  <section id="about" data-testid="about-section" className="bg-ivory py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-20">
        {/* Image feature with editorial inset */}
        <Reveal className="lg:col-span-5" y={50}>
          <div className="relative">
            <div className="glow-float absolute -inset-6 -z-10 rounded-full bg-terracotta/20 blur-3xl" />
            <img
              src="/images/taj-mahal.jpg"
              alt="Nichole MacDonald"
              data-testid="about-image-main"
              loading="lazy"
              className="aspect-[4/5] w-full rounded-[2px] object-cover"
            />
            <div className="absolute -bottom-8 -right-4 w-2/5 md:-right-10">
              <img
                src="/images/extra-tv.jpg"
                alt="Nichole on national television building Sash"
                data-testid="about-image-inset"
                loading="lazy"
                className="aspect-[4/3] w-full rounded-[2px] object-cover shadow-2xl ring-4 ring-ivory"
              />
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="lg:col-span-7">
          <Reveal><Overline>About Nichole</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Who the heck am I <span className="italic text-terracotta">to lead this?</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 font-sans text-lg font-light leading-relaxed text-stonegray">
              I'm an entrepreneur, coach, and creative who believes extraordinary lives are
              <span className="text-ink"> built, not inherited.</span>
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-6 font-sans text-lg font-light text-stonegray">Over the last two decades I've:</p>
            <ul className="mt-4 space-y-3">
              {achievements.map((a) => (
                <li key={a} className="flex items-baseline gap-3 font-sans text-lg font-light leading-relaxed text-ink">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                  {a}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 font-sans text-lg font-light leading-relaxed text-stonegray">
              I also spent 3½ years in intensive ontological leadership and coach training. I learned that strategy
              matters, but <span className="text-ink">who you're being while you execute it matters more.</span>
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 font-display text-2xl italic leading-snug text-ink md:text-3xl">
              Creating Wealth Through Community brings those two worlds together: practical entrepreneurship and deep
              personal transformation.
            </p>
          </Reveal>
        </div>
      </div>

      {/* More photos */}
      <div className="mt-20 grid grid-cols-2 gap-3 sm:grid-cols-4 md:mt-24 md:gap-4">
        {strip.map((slug, i) => (
          <Reveal key={slug} delay={i * 0.07}>
            <div className="group relative aspect-[3/4] overflow-hidden rounded-[2px] ring-1 ring-ink/5">
              <img
                src={`/images/${slug}.jpg`}
                alt="Nichole"
                data-testid={`about-photo-${slug}`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover grayscale-[0.25] transition-[filter,transform] duration-700 group-hover:scale-[1.05] group-hover:grayscale-0"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
